import { Button, Card, CardContent, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import styles from "./Styles/BookScreenStyles";
import React, { useState, useEffect } from "react";
import moment from "moment";

const ConfirmationScreen = (props) => {
    const [isDisabled, setIsDisabled] = useState(false);
    let { classes } = props;
    var confirmToBook = () => {
        setIsDisabled(true);
        props.confirmScreen.confirmToBook();
    }
    var changeDateFormat = (value) => {

        var year = "";
        var month = "";
        var day = "";

        if (value.includes("-")) {
            var dateSpliter = value.split("-");
            year = dateSpliter[0];
            month = dateSpliter[1];
            day = dateSpliter[2];
        } else {
            var dateSpliter = value.split("/");
            year = dateSpliter[2];
            month = dateSpliter[0];
            day = dateSpliter[1];
        }
        var dateConversion = new Date(year, (month - 1), day);
        var formattedDate = moment(dateConversion).format('dddd, MMMM D, Y');
        return formattedDate;
    }
    return (
        <div>
            <Grid container md={6}>
                <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="simple table">
                        <TableBody>
                            <TableRow>
                                <TableCell component="th" scope="row" align="left" style={{
                                    color: "#444"
                                }}>
                                    Location
                                </TableCell>
                                <TableCell align="left">
                                    {props.confirmScreen.location}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row" align="left" style={{
                                    color: "#444"
                                }}>
                                    Doctor
                                </TableCell>
                                <TableCell align="left">
                                    {props.confirmScreen.resourcename}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row" align="left" style={{
                                    color: "#444"
                                }}>
                                    Appointment Date and Time
                                </TableCell>
                                <TableCell align="left">
                                    {changeDateFormat(props.confirmScreen.aptDate)} at {props.confirmScreen.timing}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row" align="left" style={{
                                    color: "#444"
                                }}>
                                    First Name
                                </TableCell>
                                <TableCell align="left">
                                    {props.confirmScreen.Fname}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row" align="left" style={{
                                    color: "#444"
                                }}>
                                    Last Name
                                </TableCell>
                                <TableCell align="left">
                                    {props.confirmScreen.Lname}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row" align="left" style={{
                                    color: "#444"
                                }}>
                                    Date of Birth
                                </TableCell>
                                <TableCell align="left">
                                    {changeDateFormat(props.confirmScreen.selecteddob)}
                                </TableCell>
                            </TableRow>
                            {props.confirmScreen.apptType && (
                                <TableRow>
                                    <TableCell component="th" scope="row" align="left" style={{
                                        color: "#444"
                                    }}>
                                        Appointment Type
                                    </TableCell>
                                    <TableCell align="left">
                                        {props.confirmScreen.apptType}
                                    </TableCell>
                                </TableRow>
                            )}
                            <TableRow>
                                <TableCell component="th" scope="row" align="left" style={{
                                    color: "#444"
                                }}>
                                    Type of Visit
                                </TableCell>
                                <TableCell align="left">
                                    {props.confirmScreen.selectVisitType}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" scope="row" align="left" style={{
                                    color: "#444"
                                }}>
                                    Insurance Name
                                </TableCell>
                                <TableCell align="left">
                                    {props.confirmScreen.selectedInsName}
                                </TableCell>
                            </TableRow>
                            {props.confirmScreen.insNum.length !== 0 && (
                                <TableRow>
                                    <TableCell component="th" scope="row" align="left" style={{
                                        color: "#444"
                                    }}>
                                        Insurance Number
                                    </TableCell>
                                    <TableCell align="left">
                                        {props.confirmScreen.insNum}
                                    </TableCell>
                                </TableRow>
                            )}


                            {props.confirmScreen.selectRelationName.length > 0 && (
                                <TableRow>
                                    <TableCell component="th" scope="row" align="left" style={{
                                        color: "#444"
                                    }}>
                                        Relationship
                                    </TableCell>
                                    <TableCell align="left">
                                        {props.confirmScreen.selectRelationName}
                                    </TableCell>
                                </TableRow>
                            )}


                            <TableRow>
                                <TableCell component="th" scope="row" align="left" style={{
                                    color: "#444"
                                }}>
                                    Reason
                                </TableCell>
                                <TableCell align="left">
                                    {props.confirmScreen.selectedVisitReason}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>

            <Grid container
                className=
                {[
                    classes.marginTop20,
                    classes.centerContent
                ].join(" ")}>
                <Grid item md={12} direction="row">
                    <Button
                        variant="outlined"
                        color="primary"
                        size="large"
                        style={{ textTransform: "none" }}
                        onClick={confirmToBook}
                        disabled={isDisabled}
                    >
                        Book Now
                    </Button>
                </Grid>
            </Grid>
        </div>
    );
}
export default withStyles(styles)(ConfirmationScreen);